import type { StateManager } from '../core/StateManager';
import { DRIVE_PROFILES } from '../config/profiles';
import { escapeHtml } from '../utils/sanitize';

export class ProfileBadge {
  private unsubscribe: () => void;

  constructor(
    private element: HTMLElement,
    private state: StateManager,
  ) {
    this.update();
    this.unsubscribe = state.subscribe('selectedProfileKey', () => this.update());
  }

  private update(): void {
    const key = this.state.get('selectedProfileKey');
    const profile = DRIVE_PROFILES[key];

    if (profile) {
      this.element.dataset.vendor = profile.vendor;
      this.element.innerHTML =
        `<span class="led active-profile"></span>` +
        `<span class="profile-badge-text">Inversor em análise: <strong>${escapeHtml(profile.name)}</strong>` +
        `<em> (${escapeHtml(profile.modelCode)})</em></span>`;
    } else {
      delete this.element.dataset.vendor;
      this.element.innerHTML =
        `<span class="led inactive"></span>` +
        `<span class="profile-badge-text">Inversor em análise: —</span>`;
    }
  }

  destroy(): void {
    this.unsubscribe();
  }
}
